import { Link } from "react-router-dom";

export type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-1.5 text-[12px] text-foreground-500">
        {items.map((item, i) => (
          <li key={`${item.label}-${i}`} className="flex items-center gap-1.5">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
            )}
            {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400" />}
          </li>
        ))}
      </ol>
    </nav>
  );
}